var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 11.5,
    stroke: "#BABABA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0059 28.3101C42.0059 27.159 41.9106 26.319 41.7043 25.4479H28.2916V30.6434H36.1646C36.0059 31.9346 35.1488 33.879 33.244 35.1856L33.2173 35.3596L37.4581 38.5792L37.7519 38.6079C40.4503 36.1657 42.0059 32.5723 42.0059 28.3101Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2879 41.9917C32.145 41.9917 35.383 40.7471 37.7482 38.6005L33.2402 35.1782C32.0339 36.0026 30.4148 36.5782 28.2879 36.5782C24.5102 36.5782 21.3038 34.136 20.1609 30.7604L19.9933 30.7744L15.5837 34.1189L15.526 34.276C17.8752 38.8493 22.7006 41.9917 28.2879 41.9917Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1639 30.7673C19.8623 29.8962 19.6878 28.9628 19.6878 27.9984C19.6878 27.0339 19.8623 26.1006 20.148 25.2295L20.1401 25.044L15.6751 21.6458L15.529 21.7139C14.5608 23.6117 14.0052 25.7429 14.0052 27.9984C14.0052 30.254 14.5608 32.385 15.529 34.2828L20.1639 30.7673Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.288 19.4133C30.9705 19.4133 32.78 20.5488 33.8117 21.4978L37.8435 17.64C35.3674 15.3845 32.1451 14 28.288 14C22.7006 14 17.8752 17.1422 15.526 21.7155L20.145 25.2311C21.3039 21.8555 24.5102 19.4133 28.288 19.4133Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.64db89df4f4b72785de8b9e7d75a71c5.svg";
export { ForwardRef as ReactComponent };